import { AgentProviderConnection, AgentSettings, AgentTaskKey } from '../types';

export type ProviderCapability = 'TEXT' | 'AUDIO' | 'DOCUMENT';

export const providerCapabilities = (type: string): ProviderCapability[] => {
  if (type === 'GEMINI') return ['TEXT', 'AUDIO', 'DOCUMENT'];
  if (type === 'OPENROUTER') return ['TEXT'];
  if (type === 'DEEPSEEK') return ['TEXT'];
  if (type === 'OPENAI') return ['TEXT'];
  if (type === 'ANTHROPIC') return ['TEXT'];
  if (type === 'CUSTOM') return ['AUDIO', 'DOCUMENT'];
  return [];
};

export const taskRequirement = (task: AgentTaskKey): ProviderCapability => {
  if (task === 'VOICE_TRANSCRIPT') return 'AUDIO';
  if (task === 'DOCUMENT_EXTRACTION') return 'DOCUMENT';
  return 'TEXT';
};

export const capabilityLabel = (capability: ProviderCapability) => {
  if (capability === 'AUDIO') return 'Audio';
  if (capability === 'DOCUMENT') return 'Document';
  return 'Text';
};

export const routeCompatibility = (task: AgentTaskKey, connection?: AgentProviderConnection | null) => {
  if (!connection) {
    return { ok: false, message: 'No provider connection selected for this task.' };
  }
  if (connection.enabled === false) {
    return { ok: false, message: `${connection.label} is disabled.` };
  }
  const required = taskRequirement(task);
  const supported = providerCapabilities(connection.type);
  if (!supported.includes(required)) {
    return {
      ok: false,
      message: `${connection.label} does not support ${capabilityLabel(required).toLowerCase()} tasks in the current implementation.`,
    };
  }
  return {
    ok: true,
    message: `${connection.label} supports ${capabilityLabel(required).toLowerCase()} tasks.`,
  };
};

export const validateAgentTaskRouting = (agentSettings: AgentSettings) => {
  const providerConnections = Array.isArray(agentSettings.providerConnections) ? agentSettings.providerConnections : [];
  const invalidRoutes = (Object.entries(agentSettings.taskRouting || {}) as Array<[AgentTaskKey, { connectionId?: string }]>)
    .map(([task, route]) => {
      const connection = providerConnections.find(item => item.id === route?.connectionId) || null;
      const compatibility = routeCompatibility(task, connection);
      return compatibility.ok ? null : { task, message: compatibility.message };
    })
    .filter(Boolean) as Array<{ task: AgentTaskKey; message: string }>;

  return {
    ok: invalidRoutes.length === 0,
    invalidRoutes,
  };
};
